<template>
  <div class="mapListBox">
    <ul class="dataList">
      <li v-for="item in dataLists" :key="item.value" class="mapLi clearfix">
        <img :src="item.url" alt="" class="mapImg">
        <div class="dataInfo msgInfo">
          <h4>空间数据模块</h4>
          <p>
            {{item.remark}}
          </p>
          <button class="seeMapBtn" @click="goToMap(item)">地图浏览</button>
        </div>
        <div class="time">
          <span class="grayTxt">发布人：地图大神</span>
          <span class="grayTxt">2019-11-29 20:20:20</span>
        </div>
      </li>
    </ul>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    

  </div>
</template>

<script>
export default {
  name: 'mapLists',
  data(){
    return {
      form:{
        name:'',
        remark:''
      },
      dataLists:[
        {url:'../../images/photo06.png',value:1,remark:'空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用',
          typeName:"MapServer",
          ifCaching:"1",
          id:'111',
          restUrl:"http://192.168.59.202:6080/arcgis/rest/services/portal/HuBei/MapServer",
          xmin:108.36863601641,
          ymin:29.031078201771397,
          xmax:116.137094593131,
          ymax:30.657398631659245
        },
        {url:'../../images/photo07.png',value:2,remark:'空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用'},
        {url:'../../images/photo08.png',value:3,remark:'空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用'},
        {url:'../../images/photo09.png',value:4,remark:'空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用空间数据模块,农业地图应用,农业地图应用,农业地图应用农业地图应用,农业地图应用,农业地图应用农业地图应用'}
      ],
      currentPage:1,
      size:10,
      total:55
    }
  },
  created(){
  },
  methods:{
    //跳转地图页面
    goToMap(val){
       this.$router.push({name:'map',query:val});
    },
    handleSizeChange(){},
    handleCurrentChange(){}
  }
}
</script>

<style scoped>
.mapListBox{width:100%;padding:20px;border-radius:5px;box-shadow:0 0 30px #dae5f0;text-align:left;}

.msgInfo h4{color:#4da1ff;font-size:14px;}
.mapListBox .msgInfo{width:60%;margin-left:20px;line-height:20px;text-align:left;font-size:12px;color:#526281;}
.mapLi{padding:23px 20px;width:100%;box-sizing:border-box;border-bottom:1px solid #eee;}
.mapListBox .mapLi{padding:20px 10px;}
.mapLi:last-child{border:0;}
.msgInfo,.mapImg{float:left;}
.time{float:right;font-size:12px;}
.time span:last-child{display:inline-block;margin:0 0 0 25px;}
.mapImg{width:170px;min-height:100px;}
.mapListBox .dataInfo h4{margin-bottom:4px;}
.mapListBox .dataInfo p{color:#a1aac4}
.dataInfo{line-height:18px;}
.grayTxt,.stateTime{color:#a1aac4}
.seeMapBtn{margin-top:6px;}
</style>
